import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppStore } from '../store';

const Sidebar: React.FC = () => {
  const { ui } = useAppStore();

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  const sidebarVariants = {
    closed: {
      x: '100%',
      transition: {
        type: 'tween',
        duration: 0.3,
        ease: 'easeInOut'
      }
    },
    open: {
      x: 0,
      transition: {
        type: 'tween',
        duration: 0.3,
        ease: 'easeInOut',
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    closed: { opacity: 0, x: 20 },
    open: { opacity: 1, x: 0 }
  };

  const overlayVariants = {
    closed: { opacity: 0 },
    open: { opacity: 1 }
  };

  return (
    <AnimatePresence>
      {ui.sidebarOpen && (
        <>
          {/* Overlay */}
          <motion.div
            variants={overlayVariants}
            initial="closed"
            animate="open"
            exit="closed"
            onClick={ui.toggleSidebar}
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          />

          {/* Sidebar */}
          <motion.div
            variants={sidebarVariants}
            initial="closed"
            animate="open"
            exit="closed"
            className="fixed top-0 right-0 h-full w-64 shadow-2xl z-50 lg:hidden bg-white flex items-center justify-center"
          >
            {/* Navigation - Centered */}
            <nav className="w-full px-8">
              <motion.div variants={itemVariants} className="space-y-8">
                {navItems.map((item) => {
                  const isActive = window.location.pathname === item.href;
                  return (
                    <motion.a
                      key={item.name}
                      href={item.href}
                      onClick={ui.toggleSidebar}
                      onTouchStart={() => {}}
                      whileTap={{ scale: 0.95 }}
                      className="block text-center text-2xl font-medium transition-colors duration-300 cursor-pointer touch-manipulation"
                      style={{ 
                        WebkitTapHighlightColor: 'transparent',
                        touchAction: 'manipulation',
                        userSelect: 'none',
                        color: isActive ? '#60a5fa' : '#000000'
                      }}
                      onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        if (!isActive) {
                          e.currentTarget.style.color = '#60a5fa';
                        }
                      }}
                      onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        if (!isActive) {
                          e.currentTarget.style.color = '#000000';
                        }
                      }}
                    >
                      {item.name}
                    </motion.a>
                  );
                })}
              </motion.div>
            </nav>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Sidebar;